import { render, staticRenderFns } from "./AdditionalAttachmentsToTender.vue?vue&type=template&id=1a59404a"
import script from "./AdditionalAttachmentsToTender.vue?vue&type=script&lang=js"
export * from "./AdditionalAttachmentsToTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports